import styled, { css } from 'styled-components';

const StatusPillStyled = styled.div`
  ${() => {
    return css`
      text-align: left;
      &.status-pill {
        padding: 0 0.5em;
        border-radius: 0.188em;
        font-weight: 400;
        font-size: 0.875em;
        line-height: 1.5em;
      }
      &.status-pill--blue {
        background-color: var(--color-blue);
        border: 0.125em solid var(--color-blue);
      }
      &.status-pill--teal {
        background-color: var(--color-teal);
        border: 0.125em solid var(--color-teal);
      }
      &.status-pill--charcoal {
        background-color: var(--color-charcoal);
        border: 0.125em solid var(--color-charcoal);
      }
      &.status-pill--cobalt {
        background-color: var(--color-cobalt);
        border: 0.125em solid var(--color-cobalt);
      }
      &.status-pill--grey {
        background-color: var(--color-grey);
        border: 0.125em solid var(--color-grey);
      }
      &.status-pill--green {
        background-color: var(--color-green);
        border: 0.125em solid var(--color-green);
      }
      &.status-pill--pink {
        background-color: var(--color-pink);
        border: 0.125em solid var(--color-pink);
      }
      &.status-pill--orange {
        background-color: var(--color-orange);
        border: 0.125em solid var(--color-orange);
      }
      &.status-pill--violet {
        background-color: var(--color-violet);
        border: 0.125em solid var(--color-violet);
      }
      &.status-pill--red {
        background-color: var(--color-red);
        border: 0.125em solid var(--color-red);
      }
      &.status-pill--ruby {
        background-color: var(--color-ruby);
        border: 0.125em solid var(--color-ruby);
      }
      &.status-pill--yellow {
        background-color: var(--color-yellow);
        border: 0.125em solid var(--color-yellow);
      }
      &.status-pill--solid {
        color: var(--secondary-color);
      }
      &.status-pill--hollow {
        color: var(--color-neutral-60);
        background-color: transparent;
      }
    `;
  }}
`;

export default StatusPillStyled;
